/** @format */

import eventConstants from '@tenant/app/utils/constants/event';

export function urlOfferTypeToFlow(urlOfferType) {
    const { FLOWS, URL_OFFER_TYPES } = eventConstants;

    return FLOWS[URL_OFFER_TYPES[urlOfferType]];
}
